import { useState } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";

import { getLabel, getLanguage } from "../../tools/Dictionary";

const ReportStatus = (props) => {

  //Props
  //const IsDesktop = props.IsDesktop;
  const Status = props.Status;
  const Data = props.Data;
  const OnCloseModal = props.OnCloseModal;
  const OnClickSave = props.OnClickSave;

  //State
  const [status, setStatus] = useState(Data.status);

  const [loading] = useState(false);
  const [alert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  const onClickItem = (_status) => {

    setStatus(_status);
    OnClickSave(_status)
    OnCloseModal();

  };

  const onClickSave = () => {

    OnClickSave(status)
    OnCloseModal();
  };

  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "600px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ReportPage", "Change Status")}
        </div>
        <div className="page_modal_body_cont">
          {Status.map((s, index) => (
            <div className={"report_status_item page_noselect " + (status.code == s.code ? "report_status_item_selected" : "")} key={index} onClick={() => onClickItem(s)}>
              <div className="report_status_item_col" style={{width: "10%"}}>
              </div>
              <div className="report_status_item_col" style={{ width: "80%" }}>
                {s.label[getLanguage()] || s.label["EN"] || "-"}
              </div>
              <div className="report_status_item_col" style={{ width: "10%" }}>
              </div>
              
            </div>
          ))}
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Save")}
            style={{ maxWidth: "200px" }}
            onClick={(loading) ? undefined : onClickSave}
          />
        </div>
      </div>
    </div>
  );

};

export default ReportStatus